import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { AIChatbot } from './components/AIChatbot';
import { ScrollProgress } from './components/ScrollProgress';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { EdoCase } from './pages/EdoCase';
import { Portfolio } from './pages/Portfolio';
import { Clients } from './pages/Clients';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <ScrollProgress data-id="element-2" />
        <Navigation data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
          <Route path="/edo-case-study" element={<EdoCase data-id="element-12" />} data-id="element-11" />
          <Route path="/portfolio" element={<Portfolio data-id="element-14" />} data-id="element-13" />
          <Route path="/clients" element={<Clients data-id="element-16" />} data-id="element-15" />
          <Route path="/contact" element={<Contact data-id="element-18" />} data-id="element-17" />
        </Routes>
        <Footer data-id="element-19" />
        <AIChatbot data-id="element-20" />
      </div>
    </BrowserRouter>;
}